import {AppMenu} from "mixins/menu"
import React from "react"
import Navigation from "../components/Navigation"
import NavigationItem from "../components/NavigationItem"

class AppNavigation extends React.Component {
  render() {
    return (
      <Navigation>
        {AppMenu().map(item => {
          return (
            <NavigationItem {...item} key={item.title}/>
          )
        })
        }
      </Navigation>
    )
  }
}

export default AppNavigation
